module.exports = __webpack_public_path__ + "img/yinhai_footer.f4f1b463.jpg";